<template src="./template.html"></template>
<style lang="scss" src="./styles.scss" scoped></style>

<script>
import { mapActions, mapState } from 'vuex'
import { isMobile } from 'mobile-device-detect'
import JoinGroupOverlay from '@/components/overlays/group/JoinGroupOverlay'

export default {
  name: 'GroupGallery',
  components: {
    JoinGroupOverlay,
  },
  props: {
    groups: Array,
    title: String,
    public: Boolean,
  },
  data() {
    return {
      selectedGroup: null,
      clampLines: isMobile ? 5 : 2,
    }
  },
  computed: {
    ...mapState('groups', [ 'pending' ]),
    ...mapState('auth', [ 'settings' ]),
  },
  methods: {
    ...mapActions('groups', [
      'joinGroup',
      'requestApproval',
    ]),
    closeOverlay() {
      this.selectedGroup = null
    },
    onJoinGroup(id) {
      this.joinGroup(id).then(_ => {
        this.$emit('onReloadGroups')
        this.closeOverlay()
      })
    },
    onRequestApproval(id) {
      this.requestApproval(id).then(_ => {
        this.$emit('onReloadGroups')
        this.closeOverlay()
      })
    },
    groupName(group) {
      return group.name || this.$t('group.fallback_group_name')
    },
  },
}
</script>
